// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Login from './views/Login';
import Dashboard from './views/Dashboard';
import AdminPanel from './views/AdminPanel';
import AdminDashboard from './views/AdminDashboard';
import AdminSesiones from './views/AdminSesiones';
import AdminUsuarios from './views/AdminUsuarios';
import AdminPeticiones from './views/AdminPeticiones';
import AdminAmpliaciones from './views/AdminAmpliaciones';
import AdminNoticias from './views/AdminNoticias';
import AdminLogros from './views/AdminLogros';
import AdminMedallas from './views/AdminMedallas';
import AdminFavoritos from './views/AdminFavoritos';
import AdminNotificaciones from './views/AdminNotificaciones';
import CrearPin from './views/CrearPin';
import PerfilPanel from './views/PerfilPanel';
import PerfilPeticiones from './views/PerfilPeticiones';
import PerfilAmpliaciones from './views/PerfilAmpliaciones';
import PerfilNoticias from './views/PerfilNoticias';
import PerfilNotificaciones from './views/PerfilNotificaciones';
import SeleccionarPerfil from './views/SeleccionarPerfil';
import CrearPerfil from './views/CrearPerfil';
import CambiarPin from './views/CambiarPin';
import EditarPerfil from './views/EditarPerfil';
import AdminMonitor from './views/AdminMonitor';
import AdminBackup from './views/AdminBackup';

import ProtectedRoute from './components/ProtectedRoute';

// ✅ NUEVO: páginas de descargas
import AdminDownloadsPage from './views/AdminDownloadsPage';
import UserDownloadsPage from './views/UserDownloadsPage';

function App() {
  const datosUsuario = JSON.parse(localStorage.getItem("datosUsuario")) || {};

  return (
    <Router>
      <Routes>
        {/* Públicas */}
        <Route path="/" element={<Login />} />
        <Route path="/crear-perfil" element={<CrearPerfil />} />
        <Route path="/crear-pin/:perfilId" element={<CrearPin />} />
        <Route path="/cambiar-pin" element={<CambiarPin />} />
        <Route path="/editar-perfil" element={<EditarPerfil />} />
        <Route path="/SeleccionarPerfil" element={<SeleccionarPerfil perfiles={datosUsuario.perfiles} />} />

        {/* Usuario */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute allowedRoles={['user', 'admin']}>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/usuario/dashboard"
          element={
            <ProtectedRoute allowedRoles={['user', 'admin']}>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/perfil/:id"
          element={
            <ProtectedRoute allowedRoles={['user', 'admin']}>
              <PerfilPanel />
            </ProtectedRoute>
          }
        />
        {/* 🔻 Eliminadas: favoritos / logros / misiones */}
        <Route
          path="/perfil/:id/peticiones"
          element={
            <ProtectedRoute allowedRoles={['user', 'admin']}>
              <PerfilPeticiones />
            </ProtectedRoute>
          }
        />
        <Route
          path="/perfil/:id/ampliaciones"
          element={
            <ProtectedRoute allowedRoles={['user', 'admin']}>
              <PerfilAmpliaciones />
            </ProtectedRoute>
          }
        />
        <Route
          path="/perfil/:id/noticias"
          element={
            <ProtectedRoute allowedRoles={['user', 'admin']}>
              <PerfilNoticias />
            </ProtectedRoute>
          }
        />
        <Route
          path="/perfil/:id/notificaciones"
          element={
            <ProtectedRoute allowedRoles={['user', 'admin']}>
              <PerfilNotificaciones />
            </ProtectedRoute>
          }
        />

        {/* Ruta directa a noticias */}
        <Route
          path="/noticias"
          element={
            <ProtectedRoute allowedRoles={['user', 'admin']}>
              <PerfilNoticias />
            </ProtectedRoute>
          }
        />

        {/* ✅ NUEVO: Descargas del usuario */}
        <Route
          path="/descargas"
          element={
            <ProtectedRoute allowedRoles={['user', 'admin']}>
              <UserDownloadsPage />
            </ProtectedRoute>
          }
        />

        {/* Admin */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/panel"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminPanel />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/sesiones"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminSesiones />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/usuarios"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminUsuarios />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/peticiones"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminPeticiones />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/ampliaciones"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminAmpliaciones />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/noticias"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminNoticias />
            </ProtectedRoute>
          }
        />
        {/* 🔻 Eliminada: /admin/misiones */}
        <Route
          path="/admin/logros"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminLogros />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/medallas"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminMedallas />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/favoritos"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminFavoritos />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/monitor"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminMonitor />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/notificaciones"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminNotificaciones />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/backup"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminBackup />
            </ProtectedRoute>
          }
        />
        {/* ✅ NUEVO: Gestor de descargas (admin) */}
        <Route
          path="/admin/descargas"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminDownloadsPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
